import React, { Component } from 'react';
import { Link } from 'react-router-dom';

export class Fail extends Component {
    static displayName = Fail.name;
    constructor(props) {
        super(props);
        this.state = {
            message: "",
            code: "",
        };
    }

    componentDidMount() {
        const searchParams = new URLSearchParams(window.location.search);
        this.setState({
            message: searchParams.get("message"),
        });
    }

    render() {
        const message = this.state.message;

        return (
            <div id="info" className="box_section">
                <img width="100px" src="https://static.toss.im/lotties/error-spot-no-loop-space-apng.png" alt="에러 이미지" />
                <h2>카드등록을 실패했습니다.</h2>

                <div className="p-grid typography--p" style={{ marginTop: "50px" }}>
                    <div className="p-grid-col text--left" style={{ marginBottom: "10px" }}>
                        <b>에러메시지</b>
                    </div>
                    <div className="p-grid-col text--left" id="message">{message}</div>
                </div>
                <Link to="/"
                    style={{ marginTop: "30px" }}
                >
                    <button className="payment-button">확인</button>
                </Link>
            </div>
        );
    }
}
